export const SUBSCRIPTIONS = {
    COLLECTION: {
        queryKey: 'getSubscriptions',
        url: '/posTerminalSubscriptions'
    },
    DETAILS: {
        queryKey: 'getSubscription',
        url: '/posTerminalSubscriptions/:subscriptionId'
    },
    ACTIVATE: {
        url: '/posTerminalSubscriptions/:subscriptionId/activate'
    },
    ACTIVATE_MULTI: {
        url: '/posTerminalSubscriptions/activate'
    },
    TERMINATE: {
        url: '/posTerminalSubscriptions/:subscriptionId/terminate'
    },
    SCHEDULED_TERMINATE: {
        url: '/posTerminalSubscriptions/:subscriptionId/scheduledTermination'
    },
    UPDATE: {
        url: '/posTerminalSubscriptions/:subscriptionId/subscriptionPlan'
    },
    MIGRATE: {
        url: '/posTerminalSubscriptions/:subscriptionId/declareMigration'
    },
    EXPORT: {
        url: '/subscriptions/export'
    },
    CREATE_ENVELOPE: {
        url: '/posTerminalSubscriptions/:subscriptionId/posRemoteDownloads'
    }
};